import { Http } from '../../../support';

const initialState = {
  busy: false,
  isValidForm: false,
  result: undefined,
  error: undefined,
  data: {
    Fecha: '',
    TipoDeComprobante: 'Undefined',
    Moneda: 'MXN',
    MetodoPago: 'PUE',
    FormaPago: '',
    CondicionesDePago: '',
    SubTotal: '0.00',
    Descuento: '0.00',
    Total: '0.00',
    Emisor: {},
    Receptor: {},
    Conceptos: {
      Concepto: [],
    },
    Metadata: {
      cfdis_relacionados: false,
    },
  },
  // Alt data for testing
  /*
  {
    "Fecha": "",
    "TipoDeComprobante": "Nomina",
    "Moneda": "MXN",
    "MetodoPago": "PUE",
    "FormaPago": "01",
    "CondicionesDePago": "",
    "SubTotal": "0.00",
    "Descuento": "0.00",
    "Total": "0.00",
    "Emisor": {
        "id": "9686b3c8-3229-4873-8d79-c61312313240",
        "grupo": null,
        "razon_social": "ESCUELA KEMPER URGATE SA DE CV",
        "rfc": "EKU9003173C9",
        "curp": "XIQB891116MGRMZR05",
        "regimen": "601",
        "cp": "20257",
        "direccion": {
            "cp": "20257",
            "ciudad": "Cuauhtemoc",
            "estado": "Distrito Federal",
            "direccion": "Ignacio Manuel Altamirano 39"
        },
        "email": "xaamin@outlook.com",
        "status": 1,
        "created_at": "2022-06-12 11:54:20",
        "updated_at": "2022-06-12 11:54:20",
        "nomina": {
            "RegistroPatronal": "970978"
        }
    },
    "Receptor": {
        "confirmed": true,
        "id": "968f75d1-22bd-4887-857f-c6a345e24f80",
        "livemode": false,
        "grupo": null,
        "grupo_id": null,
        "razon_social": "JAVIER ESTEBAN PERALES MARTINEZ",
        "rfc": "PEMJ9511151Z5",
        "regimen": null,
        "direccion": null,
        "email": null,
        "uso_cfdi": "P01",
        "status": 1,
        "created_at": "2022-06-16 20:23:31",
        "updated_at": "2022-06-16 20:23:31",
        "nomina": {
            "Curp": "PEMJ951115HHGRRV09",
            "Banco": "021",
            "Puesto": "Diseñador",
            "Antigüedad": "P6Y22D",
            "ClaveEntFed": "JAL",
            "NumEmpleado": "005",
            "TipoRegimen": "04",
            "RiesgoPuesto": "2",
            "TipoContrato": "01",
            "PeriodicidadPago": "04",
            "NumSeguridadSocial": "0401233454",
            "SalarioBaseCotApor": "435.50",
            "FechaInicioRelLaboral": "2016-06-01",
            "SalarioDiarioIntegrado": "435.50"
        }
    },
    "Conceptos": {
        "Concepto": []
    },
    "Metadata": {
        "cfdis_relacionados": false,
        "FormaPagoDescripcion": "Efectivo (01)"
    },
    "FechaTemp": new Date()
  }
  */
};

const setPartialState = (store, data) => {
  store.setState((state) => {
    state.app.comprobantes.create = {
      ...state.app.comprobantes.create,
      ...data,
    };
  });
};

const create = async (store, meta = {}) => {
  store.setState((state) => {
    state.app.comprobantes.create.busy = true;
  });

  try {
    const response = await Http.post(`api/comprobantes`, meta);

    store.setState((state) => {
      state.app.comprobantes.create.busy = false;
      state.app.comprobantes.create.result = response;
    });
  } catch (error) {
    store.setState((state) => {
      state.app.comprobantes.create.busy = false;
      state.app.comprobantes.create.error = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.app.comprobantes.create = { ...initialState };
  });
};

const ComprobanteCreateStore = {
  state: () => initialState,
  actions: {
    setPartialState,
    create,
    reset,
  },
};

export default ComprobanteCreateStore;
